import React from 'react';

import { Button, ButtonSize, H2, P1 } from '@shared/ui';

import styles from './subscribe.module.css';

const Subscribe: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <H2>Подпишись на&nbsp;нашу рассылку</H2>
        <P1 className={styles.desc}>
          Будем присылать полезные статьи и&nbsp;уроки для различных музыкальных инструментов,
          информацию о&nbsp;новинках и&nbsp;спецпредложениях с&nbsp;выгодными условиями
        </P1>
        <div className={styles.form}>
          <input type="text" className={styles.input} placeholder="Укажите ваш Email" />
          <Button size={ButtonSize.L}>Подписаться</Button>
        </div>
      </div>
    </div>
  );
};

export default Subscribe;
